"use client";
import { usePathname } from "next/navigation";
import { useState } from "react";
import {
  cloverGreen,
  displayAgentChatList,
} from "@/app/(blank)/chatbot/utils/consts";
import { ChatBotIcon } from "./chatBotIcon";
import { lightenColor } from "@/utils/lightenColor";

export const ChatBotIframeWidget = ({ merchant }: any) => {
  const pathname = usePathname();
  // const [isMinimized, setIsMinimized] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const themeColor = cloverGreen || "#228800";
  const lightColor = lightenColor(themeColor, 80);

  if (pathname?.includes("/chatbot") || pathname?.includes("/merchantfinder")) {
    return null;
  }

  if (!merchant?.id || !displayAgentChatList.includes(merchant.id)) {
    return null;
  }

  // return (
  //   <div
  //     className={`fixed bottom-6 right-6 z-50 flex w-[90%] sm:w-[500px] flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-2xl transition-all duration-300 ease-in-out ${
  //       isMinimized ? "h-12" : "h-[900px] max-h-[90%]"
  //     }`}
  //   >
  //     <div
  //       className={`text-white flex flex-row justify-between items-center ${
  //         isMinimized ? "p-[10px]" : "p-3"
  //       }`}
  //       style={{ backgroundColor: themeColor }}
  //     >
  //       <h3 className="font-bold">{"Clover Order Agent"}</h3>
  //       <button
  //         className="cursor-pointer text-xl font-extrabold text-white hover:text-gray-200"
  //         onClick={() => setIsMinimized(!isMinimized)}
  //         aria-label={isMinimized ? "Expand" : "Minimize"}
  //       >
  //         {isMinimized ? "+" : "—"}
  //       </button>
  //     </div>
  //     <div className="flex flex-1 flex-col overflow-hidden bg-gray-50 relative">
  //       <iframe
  //         src="/chatbot"
  //         className="w-full h-full border-none"
  //         title="AI Chatbot"
  //         loading="lazy"
  //       />
  //     </div>
  //   </div>
  // );

  return (
    <div className="fixed bottom-10 right-10 z-50 flex flex-col items-end gap-4">
      <div
        className={`
          flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-2xl transition-all duration-300 ease-in-out origin-bottom-right
          ${
            isOpen
              ? "w-[90vw] sm:w-[500px] h-[600px] sm:h-[800px] max-h-[80vh] opacity-100 scale-100 translate-y-0"
              : "w-0 h-0 opacity-0 scale-50 translate-y-10 pointer-events-none"
          }
        `}
      >
        <div
          className="flex flex-row justify-between items-center p-3 text-white shrink-0"
          style={{ backgroundColor: themeColor }}
        >
          <h3 className="font-bold">Clover Order Agent</h3>
          <button
            className="cursor-pointer text-xl font-extrabold text-white hover:text-gray-200"
            onClick={() => setIsOpen(false)}
            aria-label="Close"
          >
            —
          </button>
        </div>
        <div className="flex flex-1 flex-col overflow-hidden bg-gray-50 relative">
          <iframe
            src="/chatbot"
            className="w-full h-full border-none"
            title="AI Chatbot"
            loading="lazy"
          />
        </div>
      </div>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`
          flex items-center justify-center w-[70px] h-[70px] rounded-full text-white shadow-lg
          transition-all duration-500 ease-in-out
          hover:shadow-xl hover:scale-110
          ${isOpen ? "rotate-[360deg]" : "rotate-0"}
        `}
        style={{ backgroundColor: themeColor }}
        aria-label={isOpen ? "Close Chat" : "Open Chat"}
      >
        <div className="w-[30px] h-[30px]">
          <ChatBotIcon color={lightColor} />
        </div>
      </button>
    </div>
  );
};
